import axios from "axios";

export default class DemappingReportService {
  ControllerName = "User";

  // get all data
  GetDemappingReport(tableRequest) {
    tableRequest.UserId = sessionStorage.getItem("UserId");
    tableRequest.UserType = sessionStorage.getItem("userType");
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDemappingReport`,
        tableRequest
      )
      .then((res) => res);
  }

    GetBatchCodeList() {
   
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}VerificationLog/GetBatchCode`,
        {}
      )
      .then((res) => res);
  }
 
  // get all data
  GetDamageReport(tableRequest) {
    tableRequest.UserId = sessionStorage.getItem("UserId");
    tableRequest.UserType = sessionStorage.getItem("userType");
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDamageReport`,
        tableRequest
      )
      .then((res) => res);
  }

  // Get Excel  Export Mapping data
  GetDemappingReportEX(tableRequest) {
    tableRequest.UserId = sessionStorage.getItem("UserId");
    tableRequest.UserType = sessionStorage.getItem("userType");
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDemappingReportEX`,
        tableRequest
      )
      .then((res) => res);
  }

  // get all data Mapping Test
  GetMappingReportTest(tableRequestMappingTest) {
  
    tableRequestMappingTest.UserId = sessionStorage.getItem("UserId");
    tableRequestMappingTest.UserType = sessionStorage.getItem("userType");
    return axios
      .post(
        `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetMappingReportTest`,
        tableRequestMappingTest
      )
      .then((res) => res);
      
  }
}
